"use strict";
"use client";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeamInviteConfirmationDialog = void 0;
var _resourceShareCopy = require("./resource-share-copy");
var _confirmationDialog = require("@common/components/confirmation-dialog/confirmation-dialog");
var _jsxRuntime = require("react/jsx-runtime");
var TeamInviteConfirmationDialog = exports.TeamInviteConfirmationDialog = function TeamInviteConfirmationDialog(_ref) {
  var teams = _ref.teams,
    role = _ref.role,
    resourceName = _ref.resourceName,
    resourceKind = _ref.resourceKind,
    onCancel = _ref.onCancel,
    onConfirm = _ref.onConfirm;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_confirmationDialog.ConfirmationDialog, {
    tone: "primary",
    title: (0, _resourceShareCopy.teamInviteQuestion)(teams, resourceName, role),
    message: (0, _resourceShareCopy.teamInviteConsequence)(teams, resourceKind, role),
    confirmLabel: "Invite",
    cancelLabel: "Cancel",
    onCancel: onCancel,
    onConfirm: onConfirm,
    "data-sentry-element": "ConfirmationDialog",
    "data-sentry-component": "TeamInviteConfirmationDialog",
    "data-sentry-source-file": "team-invite-confirmation-dialog.tsx"
  });
};